export { default } from './wrapper.component';
export * from './responsive-wrapper.component';
